import React from 'react';

import { flagStyles } from '../settings';

const SvgIS = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2568px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgIS;
